export default {
  // 备忘录
  memo: {
    createTiem: '创建时间',
    creater: '创建人',
    allMemo: '全部备忘',
    myCreate: '我创建的',
    shareMe: '共享给我',
    deleted: '已删除',
    thoroughDel: '彻底删除',
    outShare: '退出共享',
    resumeMemo: '恢复备忘',
    remind: '提醒',
    addMemo: '新增备忘',
    editMemo: '编辑备忘',
    areYouSure: '你确定要',
    term: '项备忘',
    noData: '您还没有添加备忘录',
    nowAdd: '现在就写备忘',
    share: '共享',
    cc: '抄送',
    selectReminderTime: '选择提醒时间',
    RemindYourselfOnly: '仅提醒自己',
    selectRelationship: '选择关联关系',
    selectedAddress: '请至少选定一个地址',
    addressAlreadyExists: '该地址已存在',
    dataAlreadyAssociated: '已关联该数据',
    pleaseSelectAssociatedData: '请选择关联数据',
    reminderTimeCannotBeEmpty: '提醒时间不能为空',
    time_error: '提醒时间不可早于当前时间',
    conten_empty: '内容不能为空',
    apply: '应用',
    seachValue: '请搜索内容'
  }
}
